<script>
import { hasAdminRole } from '@/api/Utilities.js'
import { getMyUserId } from '@/api/FirebaseUserWrapper.js'

// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAnalytics, logEvent } from 'firebase/analytics'
const analytics = getAnalytics(firebaseApp)
require('@/css/style.css')
export default {
  components: {},
  data () {
    return {
      userId: ''
    }
  },
  async created () {
    this.userId = await getMyUserId()
    // =================== GOOGLE ANALYTICS ===================
    if (hasAdminRole(this.userId)) {
      console.log('YOU ARE DEVELOPPER AND EXCLUDED FROM ANALYSIS')
    } else {
      logEvent(analytics, 'aboutTeam/aboutTeam')
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped>
.about {
  margin: auto;
  max-width: 1024px;
  padding: 1.0rem;
}
.is-rounded {
  border: 1px solid #999999;
  border-radius: 10px;
}
.is-half {
  width: 50%;
}
.subfooter {
  background-color: #191970;
  color: #fff;
  width: auto;
  padding: 3rem 1.5rem 6rem
}
</style>
<template>
  <div class="about">
    <div class="tabs is-left is-small">
      <ul>
        <li>
          <router-link to="/about">概要</router-link>
        </li>
        <li class="is-active">
          <router-link to="/about/team">チームについて</router-link>
        </li>
        <li>
          <router-link to="/about/tree">ツリーについて</router-link>
        </li>
        <li>
          <router-link to="/about/node">ふせんについて</router-link>
        </li>
      </ul>
    </div>
    <div class="columns is-multiline is-mobile">
      <div class="column is-6-tablet is-12-mobile has-text-left">
        <p class="subtitle has-text-weight-bold">チームの管理</p>
        <p class='text'>
          ユーザアイコンを選択しメニューから「チームの管理」を選ぶことで、チームの一覧を確認できます<br>
        </p>
      </div>
      <div  class="column is-6-tablet is-12-mobile">
        <img class="is-rounded is-half" src="./img/team_control.png">
      </div>
    </div>
    <hr>
    <div class="columns is-multiline is-mobile">
      <div class="column is-6-tablet is-12-mobile has-text-left">
        <p class="subtitle has-text-weight-bold">チームの追加</p>
        <p class='text'>
          チームの一覧では、あなたが所属するチーム一覧と各チームメンバーを確認できます。<br>
          「新規チーム」ボタンをクリックするとチームを新たに作成することができます。
        </p>
      </div>
      <div  class="column is-6-tablet is-12-mobile">
        <img class="is-rounded" src="./img/team_make.png">
      </div>
    </div>
    <hr>
    <div class="columns is-multiline is-mobile">
      <div class="column is-6-tablet is-12-mobile has-text-left">
        <p class="subtitle has-text-weight-bold">ユーザの追加</p>
        <p class='text'>
          あなたがチームオーナーの場合、チーム編集画面でユーザを追加できます。<br>
          Gmailアカウントを記入し「追加」ボタンを押すことでユーザをチームへの招待メールを送ることができます。
        </p>
      </div>
      <div  class="column is-6-tablet is-12-mobile">
        <img class="is-rounded" src="./img/team_add_member.png">
      </div>
    </div>
    <br>
    <div class="subfooter">
      <div class="content has-text-centered is-size-7">
        <div class="columns is-multiline is-mobile">
          <div class="column is-half">
            <router-link to="teams" class="has-text-white">
              <p>開発チーム</p>
            </router-link>
          </div>
          <div class="column">
            <router-link to="terms" class="has-text-white">
              <p>利用規約</p>
            </router-link>
          </div>
        </div>
        <div class="columns is-multiline is-mobile">
          <div class="column is-half">
            <router-link to="privacy" class="has-text-white">
              <p>プライバシー</p>
            </router-link>
          </div>
          <div class="column">
            <router-link to="contact" class="has-text-white">
              <p>お問合せ</p>
            </router-link>
          </div>
        </div>
        <p>@socialup</p>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/about/tutorial/AboutTeam.vue